import { useState, useEffect } from "react";
import { CTable, CTableHead, CTableRow, CTableHeaderCell, CTableBody, CTableDataCell, CFormInput, CButton, CContainer, CCard, CCardBody, CCardHeader, CPagination, CPaginationItem, CImage, CSpinner } from "@coreui/react";
import { apiClient } from 'services/Api';
import CIcon from '@coreui/icons-react'
import { cilNoteAdd } from '@coreui/icons'
import CompanyLogo from "components/CompanyLogo";
import DataTableComponent from "components/DataTableComponent";


const ClientsList = () => {
    const [loading, setLoading] = useState(false);
    const [clients, setClients] = useState([]);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        apiClient.get('/clients/?extended=true')
            .then(response => {
                const clients = response.data;
                setClients(clients);
            })
            .catch(error => console.error('Erro ao buscar candidaturas:', error));
    }, [page]);

    const refreshClients = async () => {
        setLoading(true);
        apiClient.put('/clients/')
            .then(response => {
                setLoading(false);
                window.location.reload();
            })
            .catch(error => console.error('Erro ao buscar candidaturas:', error));
    };

    const columns = [
        {
            name: "name",
            selector: (row) => (
                <div className="d-flex align-items-center">
                    {row.image && <div className='me-2'><CompanyLogo logo={row.image} maxWidth={100} /></div>}
                    {row.name}
                </div>
            ),
            sortable: true,
            className: 'text-center'
        },
        { name: "email", selector: (row) => row.email, sortable: true, className: 'text-center' },

    ];

    return (
        <>
            <CCard>
                <CCardHeader className="d-flex justify-content-between align-items-center">
                    <div>
                        <h3 className="mb-0">Clientes</h3>
                    </div>

                    <CButton color="primary" onClick={refreshClients} disabled={loading}>
                        &nbsp;Atualizar Clientes&nbsp;
                        {loading && <CSpinner component="span" size="sm" aria-hidden="true" />}
                    </CButton>
                </CCardHeader>
                <CCardBody>
                    <DataTableComponent
                        columns={columns}
                        data={clients}
                    />
                </CCardBody>
            </CCard>
        </>

    );
};

export default ClientsList;